<template>
    <div>
        <el-dialog title="指定用户列表" :visible.sync="isOpen" :show-close="false" :close-on-click-modal="false" z-index="1000">
            <el-table ref="selections" style="width: 100%;" border v-loading="loading" element-loading-text="拼命加载中"
                :data="userList" element-loading-spinner="el-icon-loading"
                :header-row-style="{ 'font-weight': 'bold', 'color': '#9196A0' }" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column prop="userId" label="用户ID">
                </el-table-column>
                <el-table-column prop="nickname" label="用户名">
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCancel">取 消</el-button>
                <el-button type="primary" @click="throughUserId">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import messageApi from '@/api/setting/message.js'
export default {
    props: ['open'],
    data() {
        return {
            isOpen: false,
            loading: false,
            userList: [],
            ids: "",
            userName: null,
        }
    },
    methods: {
        toggleSelection() {
            this.$refs.selections.clearSelection();
        },
        throughUserId() {
            // console.log(this.userName)
            this.$emit('getUserId', this.ids);
            this.$emit('getUserName', this.userName);
            this.isOpen = false;
            this.$emit('closeUserList', this.open);
            this.toggleSelection();
        },
        handleCancel() {
            this.toggleSelection();
            this.userName = ''
            this.$emit('getUserName', this.userName);
            this.isOpen = false;
            this.$emit('closeUserList', this.open);
        },
        // 多选
        handleSelectionChange(val) {
            this.ids = val.map(item => item.userId).join(',');
            this.userName = val.map(item => item.nickname).join(',');
        },
        getUserFunc() {
            messageApi.getUser().then(res => {
                // console.log(res);
                this.userList = res.data
            }).catch(err => {
                // console.log(err);
            })
        },
    },
    mounted() {
        this.getUserFunc()
    },
    watch: {
        open(newVal) {
            this.isOpen = newVal
        }
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/setting/message/components/UserList.vue